import { Button, Dialog } from '@cloudflare/kumo';
import type { ReactNode } from 'react';

interface SidePanelProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: ReactNode;
  /** Botão principal do rodapé (envia o formulário `formId`) */
  submitLabel?: string;
  formId?: string;
  submitting?: boolean;
  submitDisabled?: boolean;
  /** Ações extras à esquerda do rodapé (ex.: Testar) */
  footerStart?: ReactNode;
  cancelLabel?: string;
}

/** Painel lateral no estilo da Cloudflare: título, subtítulo, corpo rolável e rodapé fixo (Cancelar + ação) */
export function SidePanel({ open, onClose, title, description, children, submitLabel = 'Salvar', formId, submitting, submitDisabled, footerStart, cancelLabel = 'Cancelar' }: SidePanelProps) {
  return (
    <Dialog.Root open={open} onOpenChange={(o: boolean) => { if (!o && !submitting) onClose(); }}>
      <Dialog
        size="base"
        className="!fixed !inset-y-0 !right-0 !left-auto !top-0 !m-0 !flex !h-screen !max-h-none !w-[min(520px,100vw)] !max-w-none !translate-x-0 !translate-y-0 !flex-col !rounded-none !p-0"
        data-testid="side-panel"
      >
        <div className="border-b border-kumo-hairline px-6 pb-4 pt-6">
          <Dialog.Title className="text-xl font-semibold">{title}</Dialog.Title>
          {description && <p className="mt-1 text-sm text-kumo-subtle">{description}</p>}
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto px-6 py-5">{children}</div>
        <div className="flex items-center justify-between gap-2 border-t border-kumo-hairline px-6 py-4">
          <div className="flex gap-2">{footerStart}</div>
          <div className="flex items-center gap-2">
            <Button variant="ghost" type="button" disabled={submitting} onClick={onClose}>{cancelLabel}</Button>
            <Button variant="primary" type="submit" form={formId} loading={submitting} disabled={submitDisabled}>{submitLabel}</Button>
          </div>
        </div>
      </Dialog>
    </Dialog.Root>
  );
}
